import { render, staticRenderFns } from "./HeaderAppTips.vue?vue&type=template&id=e4c2b59a&scoped=true"
import script from "./HeaderAppTips.vue?vue&type=script&lang=js"
export * from "./HeaderAppTips.vue?vue&type=script&lang=js"
import style0 from "./HeaderAppTips.vue?vue&type=style&index=0&id=e4c2b59a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c2b59a",
  null
  
)

export default component.exports